<template>
  <div>
    <q-dialog ref="dialog" @hide="onDialogHide">
      <q-card class="q-dialog-plugin">
        <q-card-section class="row justify-center">
          <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
         <q-form
            @submit="()=>{
                if(reason) {
                    this.$emit('on-ok-click',reason)
                }
            }"
            class="q-gutter-md"
        >
            <q-card-section class="row justify-center q-mx-lg">
            <span class="text-subtitle1 text-weight-medium text-center">
                <translate>REASON_TO_DELETE_ORDER_ITEM</translate>
            </span>
            <q-input v-model="reason" style="width:100%" :rules="[ val => val && val.length > 0]"/>
            </q-card-section>
            <q-card-actions class="justify-center q-pa-md q-my-sm">
            <q-btn
                :label="$gettext('CANCEL')"
                color="grey-7"
                @click="onCancelClick"
                class="q-px-lg"
            />
            <q-btn
                :label="$gettext('DELETE')"
                color="info"
                type="submit"
                class="q-px-lg"
            />
            </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { QDialog, Dialog } from 'quasar'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'billingOrderDialogDeleteOrderItem',
  components: {
    QDialog,
    Dialog
  },
  props: {
    reason: String
  }
})
class BillingOrderDialogDeleteOrderItem extends Vue {
  reason = null;
  show () {
    this.$refs.dialog.show()
  }

  hide () {
    this.$refs.dialog.hide()
    this.reason = null
  }

  onDialogHide () {
    this.$emit('hide')
  }

  onOKClick () {
    this.$emit('ok')
    this.hide()
  }

  onCancelClick () {
    this.hide()
  }
}
export default BillingOrderDialogDeleteOrderItem
</script>
<style lang="stylus" scoped></style>
